export default __webpack_public_path__ + "static/acc-opening-banner-desktop-f2d2c5160a50e21eb22c43d059393ac1.png";